<span aria-label="HDZB LOGO" [inlineSVG]="'../../../../assets/img/cubee-logo.svg'"></span>
<p>© 2021 CUBEE.COM All Rights Reserved.</p>
